const date_to_timestamp = (date: Date|null): number|null => {
    if (!date) {
        return null;
    }
    let timestamp: number = Math.floor(date.getTime() / 1000);
    return timestamp;
};

export default date_to_timestamp;
